import { CommonAxiosService } from "../common-axios-service";

export class RolesService extends CommonAxiosService {
    private controller = '/roles';

    async createRole(data: any) {
        return this.axiosPostCall(this.controller, data);
    }

    async updateRole(id: number, data: any) {
        return this.axiosPutCall(`${this.controller}/${id}`, data);
    }

    async deleteRole(id: number) {
        return this.axiosDeleteCall(`${this.controller}/${id}`);
    }

    async getRoles() {
        return this.axiosGetCall(this.controller);
    }

    async assignRole(data: { userId: number, roleId: number }) {
        return this.axiosPostCall(`${this.controller}/assign`, data);
    }
}
